import { Component } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { MessageService } from 'primeng/api';
import { Mesure } from 'src/app/shared/models/mesure';
import { AuthService } from 'src/app/shared/service/auth/auth.service';
import { FecthDataService } from 'src/app/shared/service/fetchservice/fetchservice';
import { ParameterService } from 'src/app/shared/service/params/param';
import { LocalStorageService } from 'src/app/shared/service/storage/localstorage.service';

@Component({
  selector: 'app-add-parametrage-unite-mesure',
  templateUrl: './add-parametrage-unite-mesure.component.html',
  styleUrl: './add-parametrage-unite-mesure.component.scss'
})


export class AddParametrageUniteMesureComponent {
  item: Mesure = new Mesure();
  departementItems: any;
  categorieProduitItems: any;
  uniteItems: any;
  etatProduitItems: any;
  varieteItems: any;
  photoPreview: string | ArrayBuffer | null = null;
  visible: boolean = false;

  position: string = 'center';
  constructor(
    private modalService: NgbModal,
    private messageService: MessageService,
    private authService: AuthService,
    private fecthDataService: FecthDataService,
    private ngxService: NgxUiLoaderService,
    private localStorage: LocalStorageService,
    private paramService: ParameterService,
    private ngxservice: NgxUiLoaderService

  ) { }



  ngOnInit() {
    this.item.user_id = this.localStorage.getUsers()?.data?.reference;
  }



  close() {

    this.modalService.dismissAll();
  }

  addMesure() {
    if (!this.item.canSave()) {
      this.messageService.add({ severity: 'info', summary: "AfriCereal", detail: this.item.getErrorMessage() });
      return;
    } 
    else {
      this.ngxservice.start();   
      this.paramService.addMesure(this.item).subscribe(
        (response: any) => {
          this.ngxservice.stop();
          this.modalService.dismissAll();
          this.messageService.add({
            severity: 'success',
            summary: "AfriCereal",
            detail: response.message,
          });
          this.fecthDataService.notifySeriviceCreated();
        },
        (error: any) => {
          this.ngxservice.stop();
          this.messageService.add({
            severity: 'error',
            summary: "AfriCereal",
            detail: error,
          });
        }
      );
    }
  }

}
